export class Parameters {
  limit: number = 0;
  offset: number = 0;
  orderBy: string = 'id';
  orderDir: string = 'desc';
  conditions: any = {};

  constructor(limit: number = 10, offset: number = 0) {
    this.limit = limit;
    this.offset = offset;
  }

  toStringParams(): { [param: string]: string | string[] } {
    return {
      limit: this.limit + '',
      offset: (this.offset * this.limit) + '',
      orderBy: this.orderBy,
      orderDir: this.orderDir,
      ...this.conditions
    };
  }
}
